import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { WindowRef } from '../../../../services/windowRef';
import { ConfigService } from '../../../../services/configuration.service';

@Component({
  selector: 'otp-input',
  templateUrl: './otp-input.component.html',
})
export class OtpInputComponent implements AfterViewInit {
  @Input()
  submitted: boolean = false;

  @Input()
  fieldName: string = 'code';

  @Input()
  requiredErrorMessage: string;

  @Input() ariaLabel: string;

  get fieldNameError(): string {
    return `${this.fieldName}Error`;
  }

  get fieldErrorTestId(): string {
    return `text-inline-required-${this.fieldName}`;
  }

  @Output()
  onChange = new EventEmitter();
  codeInput = new FormControl(
    null,
    Validators.compose([Validators.required, Validators.pattern('^[0-9]{6}$')])
  );
  isMobileView: boolean;

  constructor(
    private windowRef: WindowRef,
    private configService: ConfigService
  ) {}

  ngOnInit() {
    this.isMobileView = this.configService.Get('mobileView');
  }

  ngAfterViewInit() {
    this.windowRef.getElementById(this.fieldName).focus();
  }

  onInputChangeHandler(): void {
    this.onChange.emit(this.submit());
  }

  keyPress(event: KeyboardEvent) {
    // Avoid enter key being disabled
    if (event.key === 'Enter') return true;
    return /^([0-9])$/.test(event.key);
  }

  public submit(): string {
    return this.codeInput.value.toLocaleString();
  }

  public reset(): void {
    this.codeInput.setValue('');
  }

  public isValid(): boolean {
    return this.codeInput.valid;
  }

  public showError(): boolean {
    return this.requiredErrorMessage && !this.isValid() && this.submitted;
  }
}
